if (!customElements.get('sample-form')) {
  customElements.define('sample-form', class SampleForm extends HTMLElement {
    constructor() {
      super();

      this.constSingleId = 'single';
      this.constAssortTitle = 'アソート';
      this.productData = document.querySelector('product-data').getProductData();
      this.variantData = this.productData.variant;
      if (this.variantData[this.constSingleId] && this.variantData[this.constSingleId].length > 0) {
        this.initSampleSelect();
      }

      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    initSampleSelect() {
      this.sampleSelect = document.querySelector('.js-sample-select');
      if (!this.sampleSelect) return;

      this.isSampleAssort = false;
      const isSampleAssortStr = this.querySelector('.js-is-sample-assort').textContent;
      if (isSampleAssortStr === 'true') {
        this.isSampleAssort = true;
      }

      const fragment = document.createDocumentFragment();
      if (!this.isSampleAssort) {
        // 通常サンプル
        this.optionVariant = this.variantData[this.constSingleId].filter(variant => variant.isAvailable);
        this.optionVariant.forEach((variant) => {
          let option = document.createElement('option');
          option.value = variant.id;
          option.textContent = variant.title;
          fragment.appendChild(option);
        })
      } else {
        let option = document.createElement('option');
        option.textContent = this.constAssortTitle;
        fragment.appendChild(option);
      }

      this.sampleSelect.appendChild(fragment);
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);

      if (!this.isSampleAssort) {
        // 通常商品。サンプル商品のデータをpropetiesに追加
        const targetVariant = this.optionVariant[this.sampleSelect.selectedIndex];
        formData.append('properties[商品]', this.productData.title);
        formData.append('properties[タイプ]', targetVariant.title);
        formData.append('properties[_product_id]', this.productData.id);
        formData.append('properties[_product_handle]', this.productData.handle);
        formData.append('properties[_variant_id]', targetVariant.id);
      } else {
        // アソート。variant_idがないため、それ以外のデータをpropetiesに追加
        formData.append('properties[商品]', this.productData.title);
        formData.append('properties[タイプ]', this.constAssortTitle);
        formData.append('properties[_product_id]', this.productData.id);
        formData.append('properties[_product_handle]', this.productData.handle);
      }

      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          this.cartNotification.renderContents(response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.sample-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.sample-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}